// 简单加密解密

const CryptoJS = require('crypto-js');

const encrypAES = (text, key) => {
  if (!text) {
    return '';
  }

  if (!key) {
    return text;
  }

  const aesKey = CryptoJS.enc.Utf8.parse(key);

  let encrypText = CryptoJS.AES.encrypt(text, aesKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypText.toString();
}

const decrypDES = (text,key) => {
  if (!text) {
    return '';
  }

  if (!key) {
    return text;
  }

  const aesKey = CryptoJS.enc.Utf8.parse(key);

  let decryptText = CryptoJS.AES.decrypt(text, aesKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  let decrypted = decryptText.toString(CryptoJS.enc.Utf8);

  if (!decrypted) {
    return text;
  }

  return decrypted;
}

export default {
  encrypAES,
  decrypDES,
}
